/** Shared label maps for capability-related display strings.
 *  Single source of truth for PRACTICE_AREA_LABELS, SCOPE_LABELS, TYPE_LABELS. */

import type { CapabilityType } from "./capability";
import type { KnowledgeAssetType } from "./knowledge";

export const PRACTICE_AREA_LABELS: Record<string, string> = {
  // AI 能力执业领域编码（docs/glossary.md）；既有码沿用原显示标签，仅补齐缺失码
  merger_acquisition: "并购",
  litigation: "诉讼",
  employment: "劳动",
  compliance: "合规",
  data_privacy: "数据合规",
  contract: "合同",
  intellectual_property: "知识产权",
  // capital_markets（2026-08-24 新增，docs/glossary.md 262 行「AI 能力执业领域
  // 编码」）：境内资本市场与发行上市业务，独立执业方向，不借用
  // merger_acquisition。此前仅作知识目录遗留编码收录于此，标签值不变，随
  // PRACTICE_AREAS（types/capability.ts）晋升为 AI 能力执业领域正式编码后随之
  // 挪进这一组，登记顺序与 PRACTICE_AREAS 一致（data_privacy 之后、
  // cross_border_us 之前）。
  capital_markets: "资本市场",
  cross_border_us: "涉外·美国法",
  cross_border_hk_ipo: "涉外·香港 IPO",
  // 知识目录遗留编码（保留向后显示，不进 AI 能力筛选清单）
  ip: "知识产权",
  real_estate: "房地产",
  banking_finance: "银行金融",
  corporate: "公司事务",
  general: "一般",
};

export const SCOPE_LABELS: Record<string, string> = {
  personal: "个人",
  tenant: "律所",
  matter_type: "事项类型",
  // US-G03 自定义顾问团队范围（CapabilityCard 的 SCOPE_BADGE_CLASS 已预留
  // team 样式，此前无数据触发，标签一并补齐）。
  team: "团队",
};

export const CAPABILITY_TYPE_LABELS: Record<CapabilityType, string> = {
  skill: "专项功能",
  agent: "智能顾问",
  playbook: "规则集",
  mcp_tool: "MCP 工具",
};

export const KNOWLEDGE_TYPE_LABELS: Record<KnowledgeAssetType, string> = {
  template: "模板",
  checklist: "检查清单",
  example: "范例",
};
